// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.network-cart-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 1rem 0;
}

.network-config-main-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 70px;
  padding-right: 1rem;
  padding-left: 1rem;
  margin-bottom: 70px;
}

.network-config-main-container .pt-sticky-header {
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 1px solid rgba(226, 232, 240, 0.7);
  background-color: rgba(248, 250, 252, 0.9);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  transition: background-color 0.3s ease, border-color 0.3s ease;
  margin-left: -1rem;
  margin-right: -1rem;
  margin-bottom: 1rem;
}

.dark .network-config-main-container .pt-sticky-header {
  border-bottom: 1px solid rgba(51, 65, 85, 0.7);
  background-color: rgba(15, 23, 42, 0.9);
}

.network-config-main-container .pt-header-content {
  display: flex;
  height: 4rem;
  align-items: center;
  padding-left: 1rem;
  padding-right: 1rem;
  box-sizing: border-box;
}

.network-config-main-container .pt-header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.network-config-main-container .pt-header-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.dark .network-config-main-container .pt-header-title {
  color: #f8fafc;
}

.network-inventory-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 1rem 0;
}

.back-navigation-wrapper-btn {
  width: 8% !important;
  height: 2rem !important;
}

.clear-wrapper-btn {
  height: 2rem !important;
}

.profiler-header-right {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  align-items: center;
}

.dark .internet-wrapper-text {
  color: #fff !important;
}

.internet-wrapper-text {
  gap: 1rem;
  margin-top: 1rem;
  margin-right: 0 !important;
}
.network-config-btn-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
}
.perf-graph-container {
  margin-top: 1rem;
  height: 50vh;
  width: 100% !important;
}

.perf-graph-container canvas {
  width: 100% !important;
}

.switch-profile-btn-div {
  margin: 0 !important;
  gap: 1rem;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/networkConfig/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,iDAAiD;EACjD,0CAA0C;EAC1C,2BAA2B;EAC3B,mCAAmC;EACnC,8DAA8D;EAC9D,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;EAC9C,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,SAAS;AACX","sourcesContent":[".network-cart-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin: 1rem 0;\n}\n\n.network-config-main-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-top: 70px;\n  padding-right: 1rem;\n  padding-left: 1rem;\n  margin-bottom: 70px;\n}\n\n.network-config-main-container .pt-sticky-header {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  border-bottom: 1px solid rgba(226, 232, 240, 0.7);\n  background-color: rgba(248, 250, 252, 0.9);\n  backdrop-filter: blur(24px);\n  -webkit-backdrop-filter: blur(24px);\n  transition: background-color 0.3s ease, border-color 0.3s ease;\n  margin-left: -1rem;\n  margin-right: -1rem;\n  margin-bottom: 1rem;\n}\n\n.dark .network-config-main-container .pt-sticky-header {\n  border-bottom: 1px solid rgba(51, 65, 85, 0.7);\n  background-color: rgba(15, 23, 42, 0.9);\n}\n\n.network-config-main-container .pt-header-content {\n  display: flex;\n  height: 4rem;\n  align-items: center;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  box-sizing: border-box;\n}\n\n.network-config-main-container .pt-header-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.network-config-main-container .pt-header-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n.dark .network-config-main-container .pt-header-title {\n  color: #f8fafc;\n}\n\n.network-inventory-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin: 1rem 0;\n}\n\n.back-navigation-wrapper-btn {\n  width: 8% !important;\n  height: 2rem !important;\n}\n\n.clear-wrapper-btn {\n  height: 2rem !important;\n}\n\n.profiler-header-right {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.dark .internet-wrapper-text {\n  color: #fff !important;\n}\n\n.internet-wrapper-text {\n  gap: 1rem;\n  margin-top: 1rem;\n  margin-right: 0 !important;\n}\n.network-config-btn-container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 1rem;\n}\n.perf-graph-container {\n  margin-top: 1rem;\n  height: 50vh;\n  width: 100% !important;\n}\n\n.perf-graph-container canvas {\n  width: 100% !important;\n}\n\n.switch-profile-btn-div {\n  margin: 0 !important;\n  gap: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
